import { RolePermissionObjects } from './rolePermissionObjects.constants';

export interface WorkforceTabLink {
    routerLink: string;
    title: string;
    objectId?: string;
}

export const workforceRouteConfig: WorkforceTabLink[] = [
    { routerLink: '/dashboard/workforce/shifts', title: 'Shifts' },
    {
        routerLink: '/dashboard/workforce/job-dictionary',
        title: 'Job Dictionary',
        objectId: RolePermissionObjects.JobDictionary,
    },
    {
        routerLink: '/dashboard/workforce/job-mapping',
        title: 'Job Mapping',
        objectId: RolePermissionObjects.JobDictionaryMapping,
    },
];
